import React from "react";
import classNames from "classnames";
import { VisibilityWatcher } from "@common/visibilityWatcher";
import { SelectedIcon } from "@common/selectedIcon";
import { ArrowIcon } from "./arrowIcon";
import { Props } from "./types";
import styles from "./styles.scss";

function CalendarHolidaysSelection({
  selectedCalendarHolidays,
  calendarHolidaysList,
  placeholder,
  select,
}: Props) {
  return (
    <VisibilityWatcher>
      {(isVisible, show, hide) => (
        <div
          className={classNames(styles.calendarSelection, {
            [styles.opened]: isVisible,
          })}
        >
          <div className={styles.input} onClick={isVisible ? hide : show}>
            {selectedCalendarHolidays?.uuid ? (
              <p className={styles.selection}>
                {selectedCalendarHolidays.name}
              </p>
            ) : (
              <p className={classNames(styles.selection, styles.placeholder)}>
                {placeholder}
              </p>
            )}
            <div className={styles.iconBox}>
              <ArrowIcon className={styles.icon} />
            </div>
          </div>

          {isVisible && (
            <div className={styles.list}>
              {calendarHolidaysList.map((calendar) => (
                <div
                  key={calendar.uuid}
                  className={styles.calendar}
                  onClick={() => {
                    select(calendar);
                    hide();
                  }}
                >
                  {selectedCalendarHolidays?.uuid === calendar.uuid ? (
                    <div className={styles.selectedCalendar}>
                      <div className={styles.selectedCalendarTitle}>
                        {calendar.name}{" "}
                        <SelectedIcon className={styles.selectedCalendarIcon} />
                      </div>
                    </div>
                  ) : (
                    <div>{calendar.name}</div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </VisibilityWatcher>
  );
}

export { CalendarHolidaysSelection };
